module.exports = __webpack_public_path__ + "img/top-movie.29d9d188.gif";